import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InteractionCategoryAdminComponent } from './interaction-category-admin.component';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmeCommonModule } from '../../../vme-common.module';

const routes: Routes = [
  {
    path: '',
    component: InteractionCategoryAdminComponent,
    data: { title: 'Interaction Categories Admin' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteractionCategoryAdminRoutingModule {}

@NgModule({
  imports: [
    InteractionCategoryAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [InteractionCategoryAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InteractionCategoryAdminModule {}
